import { Gifs } from "@/assets/gifs";

interface LoadingOverlayProps {
  isVisible: boolean;
}

export const LoadingOverlay = ({ isVisible }: LoadingOverlayProps) => {
  console.log("LoadingOverlay: isVisible =", isVisible);

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        backdropFilter: "blur(2px)",
      }}
    >
      <img
        src={Gifs.spinner}
        alt="Loading"
        style={{
          width: "min(104px, 28vw)",
          height: "auto",
          display: "block",
          color: "green",
        }}
      />
    </div>
  );
};
